import React from 'react'
import { Box, Icon } from '@maui/elements'
import { SearchResultDescription, SearchResultHeader, SearchResultTitle, SearchResultPill, useMemoizedDescription } from '../common'
import { cveColorTheme } from '../../details/VulnerabilityDetails/colorMaps'
const RiskRatingPill = ({ riskRating }) => {
  if (!riskRating) return null
  const type = (
    <>
      <Icon name='alert-octagon-fill' color={cveColorTheme.cve[riskRating.toLowerCase()].color} />
      <Box textStyle='bodySmall' m={0}>Risk Rating :</Box>
    </>
  )
  const value = <Box textStyle='buttonLabelSmall' m={0}>{riskRating}</Box>
  return (
    <SearchResultPill
      type={type}
      value={value}
    />
  )
}

const ExploitationStatePill = ({ exploitationState }) => {
  const type = (
    <>
      <Icon name='alert-triangle-fill' color={cveColorTheme.cve[exploitationState?.toLowerCase()]?.color} />
      <Box textStyle='bodySmall' m={0}>Exploitation State :</Box>
    </>
  )
  const value = <Box textStyle='buttonLabelSmall' m={0}>{exploitationState === null ? 'No Known' : exploitationState}</Box>
  return (
    <SearchResultPill
      type={type}
      value={value}
    />
  )
}

export const CveSearchResult = ({ data }) => {
  const {
    id,
    description,
    mve_id: mveId,
    cve_id: name,
    publish_date: date,
    executive_summary: executiveSummary,
    risk_rating: riskRating,
    exploitation_state: exploitationState
  } = data
  const formattedExecutedSummary = useMemoizedDescription(executiveSummary)
  const cveDescription = formattedExecutedSummary || description
  return (
    <Box>
      <SearchResultHeader subHeaderText='Vulnerability' date={date} />
      <SearchResultTitle
        titleIcon={<Icon name='shield-alert' size='lg' verticalAlign='-12.7px'/>}
        name={name}
        url={`/vulnerabilities/${id}`}
      />
      {
        mveId && (
          <Box pt='8px' pb='8px'>
            <Box
              textStyle='caption'
              fontSize='10px'
              color='colorTextDeemphasis'
              textOverflow='ellipsis'
              overflow='hidden'
              whiteSpace='nowrap'
            >
              {mveId}
            </Box>
          </Box>
        )
      }
      <Box pt='12px' display='flex' gap='8px'>
        <ExploitationStatePill exploitationState={exploitationState}/>
        <RiskRatingPill riskRating={riskRating}/>
      </Box>
      <SearchResultDescription description={cveDescription}/>
    </Box>
  )
}
